if (!customElements.get('new-image-with-text-slider')) {
  customElements.define(
    'new-image-with-text-slider',
    class NewImageWithTextSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.numberSlider = this.dataset.numberSlider === 'number';

        this.swipers = this.querySelectorAll('.swiper');
        this.sliderControls = this.querySelector('.swiper-controls');
        this.sectionId = this.dataset.sectionId;
        this.selectedIndex = this.selectedIndex;
        this.swiperInstances = [];

        if (!this.enableSlider) return;

        this.initSlider();
      }

      static get observedAttributes() {
        return ['selected-index'];
      }

      get selectedIndex() {
        return parseInt(this.getAttribute('selected-index')) || 0;
      }

      set selectedIndex(index) {
        this.setAttribute('selected-index', `${index}`);
      }

      initSlider() {
        const additionModules = [
          FoxTheme.Swiper.Autoplay
        ];

        this.swipers.forEach((swiper, swiperIndex) => {
          const autoplayDelay =
            parseInt(swiper.dataset.autoplay, 10) || 0;

          const isMediaSlider =
            swiper.classList.contains('image-slider__media');

          const paginationEl =
            isMediaSlider && this.sliderControls
              ? this.sliderControls.querySelector('.swiper-pagination')
              : null;

          const sliderOptions = {
            loop: true,
            speed: 500,

            /*
             * Image slider:
             * Show current image + part of next image
             *
             * Content slider:
             * Show only one content slide
             */
          slidesPerView: isMediaSlider ? 1.18 : 1,
spaceBetween: isMediaSlider ? 10 : 0,

...(isMediaSlider && {
  breakpoints: {
    0: {
      slidesPerView: 1.12,
      spaceBetween: 8
    },
    768: {
      slidesPerView: 1.16,
      spaceBetween: 10
    },
    1024: {
      slidesPerView: 1.18,
      spaceBetween: 10
    }
  }
}),

            ...(this.sliderControls && {
              navigation: {
                nextEl: this.sliderControls.querySelector(
                  '.swiper-button-next'
                ),
                prevEl: this.sliderControls.querySelector(
                  '.swiper-button-prev'
                )
              }
            }),

            ...(paginationEl && {
              pagination: {
                el: paginationEl,
                clickable: true,

                ...(this.numberSlider && {
                  renderBullet: function (index, className) {
                    return `
                      <span class="${className}">
                        ${index + 1}
                      </span>
                    `;
                  }
                })
              }
            }),

            on: {
              init: this.handleAfterInit.bind(this)
            },

            ...(autoplayDelay > 0 && {
              autoplay: {
                delay: autoplayDelay,
                disableOnInteraction: false
              }
            })
          };

          const sliderInstance =
            new window.FoxTheme.Carousel(
              swiper,
              sliderOptions,
              additionModules
            );

          sliderInstance.init();

          this.swiperInstances.push(sliderInstance);

          /*
           * Initial active slide UI
           */
          this.updateActiveSlide(
            sliderInstance.slider
          );

          /*
           * Real slide change
           */
          sliderInstance.slider.on(
            'realIndexChange',
            (swiperInstance) => {
              this.handleSlideChange(
                swiperInstance,
                swiper
              );
            }
          );

          /*
           * Sync image slider and content slider
           */
          sliderInstance.slider.on(
            'slideChange',
            () => {
              if (this.isSyncing) return;

              this.isSyncing = true;

              const currentIndex =
                sliderInstance.slider.realIndex;

              this.swiperInstances.forEach(
                (instance) => {
                  if (
                    instance &&
                    instance.slider &&
                    instance.slider !==
                      sliderInstance.slider &&
                    instance.slider.realIndex !==
                      currentIndex
                  ) {
                    instance.slider.slideToLoop(
                      currentIndex
                    );
                  }
                }
              );

              requestAnimationFrame(() => {
                this.isSyncing = false;
              });
            }
          );
        });

        /*
         * Shopify Theme Editor support
         */
        if (
          typeof Shopify !== 'undefined' &&
          Shopify.designMode
        ) {
          document.addEventListener(
            'shopify:block:select',
            (e) => {
              if (
                e.detail.sectionId !==
                this.sectionId
              ) {
                return;
              }

              const index = Number(
                e.target.dataset.index
              );

              if (Number.isNaN(index)) return;

              this.swiperInstances.forEach(
                (instance) => {
                  if (
                    instance &&
                    instance.slider
                  ) {
                    instance.slider.slideToLoop(
                      index
                    );

                    this.updateActiveSlide(
                      instance.slider
                    );
                  }
                }
              );
            }
          );
        }
      }

      updateActiveSlide(slider) {
        if (!slider) return;

        const {
          slides,
          activeIndex
        } = slider;

        const activeSlide =
          slides?.[activeIndex];

        if (!activeSlide) return;

        this.updateControlsScheme(
          activeSlide
        );

        this.updateContentScheme(
          activeSlide
        );

        this.updateControlsPadding(
          activeSlide
        );
      }

      onReady(selectedElement) {
        if (
          !selectedElement ||
          !FoxTheme.config.motionReduced
        ) {
          const motionEls =
            selectedElement?.querySelectorAll(
              'motion-element'
            );

          motionEls?.forEach(
            (motionEl) => {
              if (motionEl) {
                motionEl.refreshAnimation();
              }
            }
          );
        }
      }

      handleAfterInit(swiper) {
        if (!swiper) return;

        if (this.sliderControls) {
          const activeBullet =
            this.sliderControls.querySelector(
              '.swiper-pagination-bullet-active'
            );

          if (activeBullet) {
            activeBullet.classList.remove(
              'swiper-pagination-bullet-active'
            );

            activeBullet.offsetHeight;

            activeBullet.classList.add(
              'swiper-pagination-bullet-active'
            );
          }
        }

        this.updateActiveSlide(swiper);
      }

      handleSlideChange(swiper) {
        if (!swiper) return;

        const {
          slides,
          realIndex,
          activeIndex
        } = swiper;

        this.selectedIndex =
          realIndex;

        const activeSlide =
          slides?.[activeIndex];

        if (!activeSlide) return;

        this.updateControlsScheme(
          activeSlide
        );

        this.updateContentScheme(
          activeSlide
        );

        this.updateControlsPadding(
          activeSlide
        );
      }

      attributeChangedCallback(
        name,
        oldValue,
        newValue
      ) {
        if (
          name === 'selected-index' &&
          oldValue !== null &&
          oldValue !== newValue
        ) {
          const fromElements =
            this.querySelectorAll(
              `[data-swiper-slide-index="${oldValue}"]`
            );

          const toElements =
            this.querySelectorAll(
              `[data-swiper-slide-index="${newValue}"]`
            );

          fromElements.forEach(
            (fromElement) => {
              const motionEls =
                fromElement.querySelectorAll(
                  'motion-element'
                );

              motionEls.forEach(
                (motionEl) => {
                  if (
                    motionEl.hasAttribute(
                      'data-text'
                    )
                  ) {
                    motionEl.resetAnimation();
                  }
                }
              );
            }
          );

          toElements.forEach(
            (toElement) => {
              setTimeout(() => {
                if (
                  toElement.classList.contains(
                    'swiper-slide-active'
                  )
                ) {
                  const motionEls =
                    toElement.querySelectorAll(
                      'motion-element'
                    );

                  motionEls.forEach(
                    (motionEl) => {
                      if (motionEl) {
                        motionEl.refreshAnimation();
                      }
                    }
                  );
                }
              }, 0);
            }
          );
        }
      }

      updateControlsScheme(activeSlide) {
        if (
          !this.sliderControls ||
          !activeSlide
        ) {
          return;
        }

        const classesToRemove =
          Array.from(
            this.sliderControls.classList
          ).filter((className) =>
            className.startsWith(
              'color-'
            )
          );

        classesToRemove.forEach(
          (className) =>
            this.sliderControls.classList.remove(
              className
            )
        );

        const colorScheme =
          activeSlide.dataset.colorScheme;

        if (colorScheme) {
          this.sliderControls.classList.add(
            colorScheme
          );
        }
      }

      updateContentScheme(activeSlide) {
        if (!activeSlide) return;

        const content =
          this.querySelector(
            '.image-slider__content'
          );

        if (!content) return;

        const classesToRemove =
          Array.from(
            content.classList
          ).filter((className) =>
            className.startsWith(
              'color-'
            )
          );

        classesToRemove.forEach(
          (className) =>
            content.classList.remove(
              className
            )
        );

        const colorScheme =
          activeSlide.dataset.colorScheme;

        if (colorScheme) {
          content.classList.add(
            colorScheme
          );
        }
      }

      updateControlsPadding(
        activeSlide
      ) {
        if (
          !this.sliderControls ||
          !activeSlide
        ) {
          return;
        }

        const controlsElement =
          Array.from(
            this.sliderControls.classList
          ).filter((className) =>
            className.startsWith(
              'color-inherit'
            )
          );

        controlsElement.forEach(
          (className) =>
            this.sliderControls.classList.remove(
              className
            )
        );

        const paddingCustom =
          activeSlide.dataset.padding ===
          'custom';

        this.sliderControls.classList.toggle(
          'color-inherit',
          paddingCustom
        );
      }
    }
  );
}